import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 导入 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("导入")
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "hw_detail_table_container card-white-6"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("添加")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_we_table = _resolveComponent("we-table")!
  const _component_page_wrapper = _resolveComponent("page-wrapper")!

  return (!_ctx.isInserted)
    ? (_openBlock(), _createBlock(_component_page_wrapper, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_component_we_table, {
            onRegister: _ctx.register,
            activeKey: _ctx.tab,
            "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event))
          }, {
            headerButton: _withCtx(() => [
              (_ctx.hasPermission('CanDoGsuiteBilling') && _ctx.is_guite_config)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    type: "primary",
                    onClick: _ctx.importGsuiteConfigData
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    onClick: _ctx.importGsuiteDetailData,
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
            ]),
            rd_manual_invoice: _withCtx(({ text, record }) => [
              (_ctx.isEmptyData(text))
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, "-"))
                : (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    type: "link",
                    onClick: ($event: any) => (_ctx.editManuallInvoice(record))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(text ? '人工开票' : '自动开票'), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
            ]),
            _: 1
          }, 8, ["onRegister", "activeKey"])
        ]),
        _: 1
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createVNode(_component_we_table, { onRegister: _ctx.register }, {
          "g-action": _withCtx(({ record }) => [
            _createVNode(_component_a_button, {
              type: "link",
              onClick: ($event: any) => (_ctx.editData(record))
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_a_button, {
              type: "link",
              onClick: ($event: any) => (_ctx.deleteData(record)),
              danger: ""
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          headerButton: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editData({})))
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onRegister"])
      ]))
}